import { render, staticRenderFns } from "./PageFrame.vue?vue&type=template&id=383b16bd&scoped=true&"
import script from "./PageFrame.vue?vue&type=script&lang=js&"
export * from "./PageFrame.vue?vue&type=script&lang=js&"
import style0 from "./PageFrame.vue?vue&type=style&index=0&id=383b16bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383b16bd",
  null
  
)

export default component.exports